import React, { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import logo from "../images/logo.png"

import {
  Navbar,
  NavbarBrand,
  NavbarEnd,
  NavbarMenu,
  Container
} from "bloomer"

export default class navbar extends Component {
  static propTypes = {
    siteTitle: PropTypes.string.isRequired,
  }
  state = {
    isOpen: false,
    // Título del desplegable abierto, o null. Es por título y no un booleano
    // porque hay más de uno: con un booleano compartido se abrían los dos juntos.
    submenuOpen: null,
  }

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  // El submenú "Oráculos" se abre con hover en desktop (Bulma is-hoverable) y,
  // además, con clic/tap/Enter/Espacio en el botón: accesible por teclado y
  // fiable en mobile. stopPropagation evita que el tap cierre el menú burger.
  toggleSubmenu = (e, titulo) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ submenuOpen: this.state.submenuOpen === titulo ? null : titulo })
  }

  closeSubmenuOnEscape = e => {
    if (e.key === "Escape" && this.state.submenuOpen) this.setState({ submenuOpen: null })
  }


  render() {

      const renderMenu = (items, dropdown=false )=> {
        return <div className={dropdown ? "navbar-dropdown":"navbar-end"}>
          { items.map(i => {
            if(i.menu){
              const open = this.state.submenuOpen === i.title
              return <div
                key={i.title}
                className={`navbar-item has-dropdown is-hoverable${open ? " is-active" : ""}`}
                onKeyDown={this.closeSubmenuOnEscape}
              >
              <button
                type="button"
                className="navbar-link navbar-item navbar-submenu-btn"
                aria-haspopup="true"
                aria-expanded={open ? "true" : "false"}
                onClick={e => this.toggleSubmenu(e, i.title)}
              >
                { i.title }
              </button>
              {renderMenu(i.menu, true)}
            </div>
            }else{
              return <Link 
                key={i.link}
                className="navbar-link is-arrowless"
                activeClassName="is-active"
                to={i.link}>
                { i.title }
              </Link>
            }
            
          })}
        </div>
      }



    // Siete entradas de primer nivel. Con las diez de antes la barra medía 1490px
    // y se salía de la pantalla en cualquier monitor de 1280 o menos; las
    // calculadoras de astrología pasaron a su propio desplegable.
    const links = [
      {
        "title": "Horóscopo",
        "link": "/horoscopo/"
      },
      {
        "title": "Carta do Dia",
        "link": "/carta-do-dia/"
      },
      {
        "title": "Astrologia",
        "link": "#",
        "menu": [
          {
            "title": "Mapa Astral",
            "link": "/mapa-astral/"
          },
          {
            "title": "Ascendente",
            "link": "/ascendente/"
          },
          {
            "title": "Signo Chinês",
            "link": "/signo-chines/"
          },
          {
            "title": "Compatibilidade Amorosa",
            "link": "/astrologia/compatibilidade-amorosa/"
          },
          {
            "title": "Ranking da Semana",
            "link": "/ranking-da-semana/"
          }
        ]
      },
      {
        "title": "Numerologia",
        "link": "/numerologia/"
      },
      {
        "title":"Anjos",
        "link":"/anjos/"
      },
      {
        "title":"Oráculos",
        "link":"#",
        "menu":[
          {
            "title":"Jogo de Tarot",
            "link":"/jogo-de-tarot/"
          },
          {
            "title":"Tarot Sim ou Não",
            "link":"/oraculo/tarot-sim-ou-nao/"
          },
          {
            "title":"Tarot do Amor",
            "link":"/oraculo/tarot-do-amor/"
          },
          {
            "title":"Tarot da Sorte",
            "link":"/oraculo/tarot-da-sorte/"
          },
          {
            "title":"Baralho Cigano",
            "link":"/oraculo/baralho-cigano/"
          },
          {
            "title":"Mesa Real",
            "link":"/oraculo/mesa-real/"
          },
          {
            "title":"Runas",
            "link":"/oraculo/runas/"
          },
          {
            "title":"Cristais",
            "link":"/oraculo/cristais/"
          },
          {
            "title":"Significado das cartas",
            "link":"/oraculo/tarot/"
          }
        ]
      },
      {
        "title": "Artigos",
        "link": "/artigos/"
      }
    ];

    const items = renderMenu(links);
    
    // const items = links.map(function(item, i){
    //   return (
    //     <Link
    //       key={i}
    //       to={item.link}
    //       className="navbar-link nav-item is-arrowless"
    //       activeClassName="is-active"
    //     >
    //       {item.title}
    //     </Link>
    //   )
    // }); 


    return (
      <Navbar>
        <Container>
          {/* Site title link */}
          <NavbarBrand>
            <Link to="/" className="navbar-item">
              <img src={logo} alt={this.props.siteTitle} />
            </Link>
            <button
              type="button"
              className={`navbar-burger burger${this.state.isOpen ? " is-active" : ""}`}
              aria-label="Menu"
              aria-expanded={this.state.isOpen ? "true" : "false"}
              onClick={this.toggleCollapse}
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </button>
          </NavbarBrand>
          <NavbarMenu
            isActive={this.state.isOpen}
            onClick={this.toggleCollapse}
          >
            {/* Page nav links */}
            <NavbarEnd>
              {items}
              {/* { renderMenu(data) } */}
            </NavbarEnd>
          </NavbarMenu>
        </Container>
      </Navbar>
    )
  }
}
